// Calendar and task actions are deterministic UI flows, but Athena must still
// remember that they happened as part of the conversation.
export async function persistOperationalChat({
  apiBase, token, sessionId, userMessage, assistantMessage, projectId = null,
  responsePresentation = null, fileIds = [], attachmentIds = [],
}) {
  if (!userMessage || !assistantMessage) return null;
  const response = await fetch(`${apiBase}/chat/action`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({
      session_id: sessionId || null,
      message: userMessage,
      answer: assistantMessage,
      project_id: projectId || null,
      response_presentation: responsePresentation || undefined,
      file_ids: Array.isArray(fileIds) ? fileIds.filter(Boolean).slice(0, 8) : undefined,
      attachment_refs: Array.isArray(attachmentIds) ? attachmentIds.filter(Boolean).slice(0, 8) : undefined,
    }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.detail || 'Não consegui registrar esta ação na conversa');
  return {
    sessionId: data.session_id || sessionId || null,
    responseMessageId: data.response_message_id || null,
    responsePresentation: data.response_presentation || responsePresentation || null,
  };
}

/** Presentation is data, never markup: these locally-created cards use the
 * same v1 contract as model responses and are revalidated by the Worker. */
export function reminderPresentation({ title, summary, when, items = [] }) {
  return {
    version: 1,
    mode: 'reminder',
    title,
    summary,
    card: {
      eyebrow: 'Lembrete',
      title,
      summary,
      when,
      items: items.map(text => ({ text, checked: true })),
    },
  };
}

export function taskPresentation({ title, summary, when, priority = 'Normal', items = [] }) {
  return {
    version: 1,
    mode: 'task',
    title,
    summary,
    card: {
      eyebrow: 'Tarefa',
      title,
      summary,
      when,
      items: [
        { text: title, status: priority },
        ...items.map(text => ({ text })),
      ],
    },
  };
}
